export default "__VITE_ASSET__DBVVPlQu__"